import Brain from '../img/brain.png';
import IDcard from '../img/id-card.png';
import Personaldetails from '../img/personal-data.png';
import Sun from '../img/sun.png';
import Moon from '../img/crescent-moon.png';
import Jupiter from '../img/jupiter.png';
import Rahu from '../img/rahu.png';
import Mercury from '../img/mercury.png';
import Venus from '../img/femenine.png';
import Ketu from '../img/ketu.png';
import Mars from '../img/mars.png';
import Saturn from '../img/saturn.png';

import Victim from '../img/Victim.png';
import Avoider from '../img/Avoider.png';
import Controller from '../img/Controller.png';
import Hyper_vigilant from '../img/Hyper-Vigilant.png';
import Judge from '../img/Judge.png';
import Pleaser from '../img/Pleaser.png';
import Restless from '../img/Restless.png';
import Stickler from '../img/Stickler.png';
import Hyper_Achiever from '../img/Hyper-Achiever.png';
import Hyper_Rational from '../img/Hyper-Rational.png';


const Images = {
    Brain,
    IDcard,
    Personaldetails,
     Sun,
    Moon,
    Jupiter,
    Rahu,
    Mercury,
    Venus,
    Ketu,
    Mars,
    Saturn,
    
    Victim,
    Avoider,
     Controller,
     Hyper_vigilant,
     Judge,
     Pleaser,
     Restless,
     Stickler,
     Hyper_Achiever,
     Hyper_Rational,
};

export default Images;
